/* eslint-disable @typescript-eslint/no-explicit-any */
import wifi from "../../../../assets/img/wifi.png";
import pileta from "../../../../assets/img/natacion.png";
import televisor from "../../../../assets/img/televisor.png";
import estacionamiento from "../../../../assets/img/estacionamiento.png";
import cocina from "../../../../assets/img/coccion.png";
import refrigerador from "../../../../assets/img/refrigerador.png";
import ropa from "../../../../assets/img/manta.png";
import perchas from "../../../../assets/img/percha.png";
import armario from "../../../../assets/img/armario.png";

const Servicios = ({ setForm, form }: any) => {
  const servicios = [
    {
      name: "Wifi",
      icon: wifi,
    },
    {
      name: "Pileta",
      icon: pileta,
    },
    {
      name: "Televisor",
      icon: televisor,
    },
    {
      name: "Estacionamiento",
      icon: estacionamiento,
    },
    {
      name: "Cocina",
      icon: cocina,
    },
    {
      name: "Refrigerador",
      icon: refrigerador,
    },
  ];

  const serviciosAdicionales = [
    {
      name: "Ropa de cama",
      icon: ropa,
    },
    {
      name: "Perchas",
      icon: perchas,
    },
    {
      name: "Espacio para guardar ropa",
      icon: armario,
    },
  ];

  const onClick = (e: any, value: string) => {
    switch (e.target.name) {
      case "service":
        {
          // let input = form;
          let services = form.SERVICES;
          const service = {
            id: "",
            //--'Wifi', 'Pileta', 'Televisor', 'Estacionamiento', 'Cocina', 'Refrigerador', 'Ropa de cama', 'Perchas', 'Espacio para guardar ropa',
            //--'Almuerzo', 'Desayuno', 'Merienda', 'Bebidas', 'Traslados', 'Guía profesional'
            name: value,
            porperty_id: "",
            excursion_id: "",
            created_at: "",
          };

          if (
            form.SERVICES.filter((i: { name: string }) => i.name == value)
              .length > 0
          ) {
            services = form.SERVICES.filter(
              (i: { name: string }) => i.name != value
            );
          } else {
            services.push(service);
          }

          setForm({
            ...form,
            SERVICES: services,
          });
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="h-[100%] flex justify-center items-center">
      <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
        <div>
          <span className="font-bold text-black mb-2 block">
            Contales a los huèspedes todo lo que tu espacio tiene para ofrecer
          </span>
          <span>
            Podés agregar más servicios después de publicar el anuncio.
          </span>
          <div className="grid grid-cols-2 gap-5 mb-5">
            {servicios.map((t) => {
              if (
                form.SERVICES.filter((i: { name: string }) => i.name == t.name)
                  .length > 0
              ) {
                return (
                  <label
                    className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border-black"
                    style={{ borderRadius: "20px" }}
                  >
                    <span className="flex items-center">
                      <img src={t.icon} width={20} className="me-2" alt="" />
                      {t.name}
                    </span>
                    <button
                      className="hidden"
                      name="service"
                      onClick={(event) => onClick(event, t.name)}
                    ></button>
                  </label>
                );
              }

              return (
                <label
                  className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border"
                  style={{ borderRadius: "20px" }}
                >
                  <span className="flex items-center">
                    <img src={t.icon} width={20} className="me-2" alt="" />
                    {t.name}
                  </span>
                  <button
                    className="hidden"
                    name="service"
                    onClick={(event) => onClick(event, t.name)}
                  ></button>
                </label>
              );
            })}
          </div>
          <span className="font-bold text-black mb-2 block">
            Servicios adicionales
          </span>
          <div className="grid grid-cols-2 gap-5">
            {serviciosAdicionales.map((t) => {
              if (
                form.SERVICES.filter((i: { name: string }) => i.name == t.name)
                  .length > 0
              ) {
                return (
                  <label
                    className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border-black"
                    style={{ borderRadius: "20px" }}
                  >
                    <span className="flex items-center">
                      <img src={t.icon} width={20} className="me-2" alt="" />
                      {t.name}
                    </span>
                    <button
                      className="hidden"
                      name="service"
                      onClick={(event) => onClick(event, t.name)}
                    ></button>
                  </label>
                );
              }

              return (
                <label
                  className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border"
                  style={{ borderRadius: "20px" }}
                >
                  <span className="flex items-center">
                    <img src={t.icon} width={20} className="me-2" alt="" />
                    {t.name}
                  </span>
                  <button
                    className="hidden"
                    name="service"
                    onClick={(event) => onClick(event, t.name)}
                  ></button>
                </label>
              );
            })}
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Servicios;
